var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.itemsPerPage || _vm.itemsPerPage.length === 0
        ? _c("div", { staticClass: "mt50 h5" }, [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.$t(
                    "No reviews have been posted yet. Please don't hesitate to share Your opinion and write the first review!"
                  )
                ) +
                "\n  "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.itemsPerPage, function(item, index) {
        return _c("div", { key: index, staticClass: "mt50" }, [
          _c("h4", { staticClass: "weight-400 m0" }, [
            _vm._v("\n      " + _vm._s(item.title) + "\n    ")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "cl-tertiary mt10 mb20 fs-medium-small" }, [
            _vm._v(
              "\n      " +
                _vm._s(item.nickname) +
                ", " +
                _vm._s(_vm._f("date")(item.created_at, null, _vm.storeView)) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "cl-gray lh25" }, [
            _vm._v("\n      " + _vm._s(item.detail) + "\n    ")
          ])
        ])
      }),
      _vm._v(" "),
      _vm.pageCount > 1
        ? _c(
            "div",
            { staticClass: "row middle-xs center-xs mt50" },
            [
              _c(
                "a",
                {
                  staticClass: "mr10 no-underline",
                  class: { inactive: _vm.currentPage === 1 },
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.prevPage($event)
                    }
                  }
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("chevron_left")
                  ])
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.pageList, function(pageNumber) {
                return _c(
                  "span",
                  { key: pageNumber, staticClass: "mx10 pagination-page" },
                  [
                    pageNumber === _vm.currentPage
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "fs-medium block py15 px20 bg-cl-mine-shaft cl-white"
                          },
                          [
                            _vm._v(
                              "\n        " + _vm._s(pageNumber) + "\n      "
                            )
                          ]
                        )
                      : _c(
                          "a",
                          {
                            staticClass:
                              "fs-medium block py15 px20 bg-cl-secondary pointer",
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.changePage(pageNumber)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n        " + _vm._s(pageNumber) + "\n      "
                            )
                          ]
                        )
                  ]
                )
              }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "ml10 no-underline",
                  class: { inactive: _vm.currentPage === _vm.pageCount },
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.nextPage($event)
                    }
                  }
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("chevron_right")
                  ])
                ]
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("script", {
        attrs: { type: "application/ld+json" },
        domProps: { innerHTML: _vm._s(_vm.getJsonLd) }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }